module.exports = __webpack_public_path__ + "static/img/9.10ce142.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/zh/9.png
// module id = 8EKh
// module chunks = 0